import * as React from "react";
function SvgHealthInsurance(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.512 4.493c.312.316.488.745.488 1.191v12.632c0 .447-.176.875-.488 1.19a1.657 1.657 0 01-1.179.494H3.667c-.442 0-.866-.177-1.179-.493A1.693 1.693 0 012 18.316V5.684c0-.446.176-.875.488-1.19A1.658 1.658 0 013.667 4h16.666c.442 0 .866.177 1.179.493zm-17.723 13.7a.415.415 0 00.294.123h15.834c.11 0 .216-.045.294-.123a.424.424 0 00.122-.298V9.053a.423.423 0 00-.122-.298.414.414 0 00-.294-.123H4.083a.414.414 0 00-.294.123.423.423 0 00-.122.298v8.842c0 .111.044.218.122.297zM9.292 12h.833c.166 0 .325.067.442.185a.636.636 0 01.183.447v1.263a.636.636 0 01-.183.446.622.622 0 01-.442.185h-.833a.207.207 0 00-.148.062.212.212 0 00-.06.149v.842a.636.636 0 01-.184.446.622.622 0 01-.442.186h-1.25a.622.622 0 01-.441-.186.636.636 0 01-.184-.446v-.842a.212.212 0 00-.06-.149.207.207 0 00-.148-.062h-.833a.622.622 0 01-.442-.185.636.636 0 01-.183-.446v-1.263c0-.168.066-.328.183-.447A.622.622 0 015.542 12h.833a.207.207 0 00.147-.062.211.211 0 00.061-.149v-.842c0-.167.066-.328.184-.446a.622.622 0 01.441-.185h1.25c.166 0 .325.067.442.185a.636.636 0 01.183.446v.843c0 .055.022.109.061.148.04.04.092.062.148.062zm8.75-.21h-3.959a.621.621 0 00-.442.184.635.635 0 000 .894.622.622 0 00.442.184h3.959a.622.622 0 00.442-.184.635.635 0 000-.894.622.622 0 00-.442-.185zm-3.959 2.526H17c.166 0 .325.066.442.185a.635.635 0 010 .893.622.622 0 01-.442.185h-2.917a.622.622 0 01-.442-.185.635.635 0 010-.893.621.621 0 01.442-.185z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgHealthInsurance);
export default ForwardRef;
